import { DistributionType, ProjectType } from '@aviv-search/types';
export const getAdSlotDistributionType = ({ distributionTypes = [], projectTypes = [], }) => {
    if (projectTypes.length === 1 && projectTypes[0] === ProjectType.LIFE_ANNUITY)
        return 'life_annuity';
    return distributionTypes?.[0] === DistributionType.RENT ? 'rent' : 'buy';
};
